import React from 'react';
import { db } from "firebase/fbConfig.js"
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { whiteColor } from "assets/jss/material-dashboard-pro-react.jsx";

import moment from 'moment';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from '@material-ui/core/Card';

class ChatterBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            message: ''
        }
    }

    componentDidMount() {
        this.getMessages();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.messages.length !== prevState.messages.length) {
            const messagesDiv = document.getElementById('messages');
            messagesDiv.scrollTop = messagesDiv.scrollHeight;
        }
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value,
        })
    }

    getMessages = () => {
        const watcher = db.collection('TEST-orders').doc(this.props.orderID).collection('messages').where('channel', this.props.channel === 'dispatch' ? 'in' : '==', this.props.channel === 'dispatch' ? ['dispatch', ''] : this.props.channel).orderBy('createdAt')
            .onSnapshot(querySnapshot => {
                console.log('snapshot updated');
                const snapshot = querySnapshot.docs;
                const messages = [];
                for (let i = 0; i < snapshot.length; i++) {
                    const docData = {
                        ...snapshot[i].data(),
                        id: snapshot[i].id
                    }
                    messages.push(docData);
                }

                this.setState({ messages: messages });
            })


        this.unsubscribe = watcher;
    }

    sendMessage = () => {
        db.collection('TEST-orders').doc(this.props.orderID).collection('messages').add({
            message: this.state.message,
            createdAt: new Date(),
            user: this.props.user,
            channel: this.props.channel
        })
            .then(res => {
                this.setState({ message: '' })
            })
            .catch(err => console.log(err));
    }

    render() {
        return (
            <GridContainer>
                <GridItem xs={12}>
                    <CustomInput
                        labelText="Send a Message"
                        id="message"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            required: true,
                            type: "text",
                            onChange: (event) => this.handleChange(event),
                            value: this.state.message
                        }}
                    />
                </GridItem>
                <GridItem>
                    <Button
                        style={{ float: "right", marginTop: "20px" }}
                        color="primary"
                        onClick={() => this.sendMessage()}
                    >
                        SEND
                </Button>
                </GridItem>
                <GridItem xs={12}><br /></GridItem>
                <GridItem xs={12}>
                    <GridContainer id='messages' style={{ maxHeight: '300px', overflowY: 'auto', backgroundColor: whiteColor, padding: this.state.messages.length ? '16px 8px 0 8px' : '0' }}>
                        {this.state.messages.map(m => (
                            <GridItem xs={12}>
                                <GridContainer>
                                    <Card style={{ width: '100%', padding: '8px' }}>
                                        <GridItem>
                                            <p>{moment(m.createdAt.toDate()).format('MM-DD-YYYY HH:mm')}</p>
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <p>{m.message}</p>
                                        </GridItem>
                                        <GridItem>
                                            <p>
                                                - {m.user.firstName} {m.user.lastName}
                                            </p>
                                        </GridItem>
                                    </Card>
                                    <GridItem xs={12}><br /></GridItem>
                                </GridContainer>
                            </GridItem>
                        ))}
                    </GridContainer>
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(ChatterBox);


// WEBPACK FOOTER //
// ./src/components/Chat/index.jsx